import * as THREE from 'three'
import Experience from '../../Experience.js'
import Debug from '../../Utils/Debug.js'
import Properties from "../../Properties.js";
import Resources from "@experience/Utils/Resources.js";
import * as helpers from "@experience/Utils/HelpersFunctions.js";
import Model from "./Abstracts/Model.js";

export default class UrinarySystem extends Model {
    experience = new Experience()
    debug = new Debug()
    properties = new Properties()
    scene = experience.scene
    time = experience.time
    camera = experience.camera.instance
    renderer = experience.renderer.instance
    resources = experience.resources
    cursor = experience.cursor
    timeline = experience.timeline;

    loadingModel = false;

    sources = [ {
        name: 'urinarySystemModel',
        type: 'gltfModel',
        path: 'models/urinary_system/urinary_system.gltf'
    } ]
    sourcesReady = 'UrinarySystemReady'

    container = new THREE.Group();

    constructor( body ) {
        super()
        this.body = body

        // this.setModel()
        // this.setDebug()
    }

    setModel() {
        this.urinarySystemModel = this.resources.items.urinarySystemModel.scene

        helpers.meshToBatchedMesh( this.urinarySystemModel, this.container, this.body.batchedMeshesIds )

        //this.body.changeVisibility( this.urinarySystemModel, false )

        //this.container.add( this.urinarySystemModel );
        //helpers.cloneAllMaterials( this.container );
        this.body.container.add( this.container );
    }

    resize() {

    }

    setDebug() {
        if ( !this.debug.active ) return
    }

    update( deltaTime ) {

    }

}
